import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseMlsProviderProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseMlsProvider/${props.franchiseMlsProviderId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseMlsProvider/Franchise/${props.franchiseId}`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseMlsProvider/${props.franchiseMlsProviderId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `FranchiseMlsProvider/Franchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseMlsProvider/${props.franchiseMlsProviderId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseMlsProviderStore = () => React.useContext(Context);
